// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.usersTable {
    width: 100%;
    margin: 0;
    max-height: 90vh;
    overflow-y: scroll;
}

.usersTable .noUsersToActive {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border: 1px solid white;
}

.usersTable table tr th {
    border: 2px solid #f09502;
    color: white;
    padding: 8px 12px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    background-color: #0e0f15;
}

.usersTable table tr th .info {
    max-width: 90%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.usersTable .actions button:first-child {
    margin-right: 10px;
}

.usersTable .accordion {
    padding: 8px 0 0 !important;
}

@media (max-width: 500px) {
    .usersTable button {
        width: 100%;
    }

    .usersTable .actions, .usersTable .actions button {
        width: 100%;
    }

    .usersTable .info, .usersTable .actions {
        padding: 0;
    }

    .usersTable .actions button:first-child {
        margin-right: 0;
        margin-bottom: 8px;
    }

    .usersTable .info {
        margin-bottom: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/set-kyc/set-kyc/set-kyc.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.usersTable {\n    width: 100%;\n    margin: 0;\n    max-height: 90vh;\n    overflow-y: scroll;\n}\n\n.usersTable .noUsersToActive {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    border: 1px solid white;\n}\n\n.usersTable table tr th {\n    border: 2px solid #f09502;\n    color: white;\n    padding: 8px 12px;\n    margin-bottom: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    background-color: #0e0f15;\n}\n\n.usersTable table tr th .info {\n    max-width: 90%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.usersTable .actions button:first-child {\n    margin-right: 10px;\n}\n\n.usersTable .accordion {\n    padding: 8px 0 0 !important;\n}\n\n@media (max-width: 500px) {\n    .usersTable button {\n        width: 100%;\n    }\n\n    .usersTable .actions, .usersTable .actions button {\n        width: 100%;\n    }\n\n    .usersTable .info, .usersTable .actions {\n        padding: 0;\n    }\n\n    .usersTable .actions button:first-child {\n        margin-right: 0;\n        margin-bottom: 8px;\n    }\n\n    .usersTable .info {\n        margin-bottom: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
